<template>
  <div class="mb-4" v-if="accessRequestFormPage">

    <!--#region -- Content ---->

    <div class="stage-header border-bottom mb-4">
      <div class="caption-label">Request Form List <div class="ml-3 mb-1 d-print-none"> <b-button @click="newRequestForm" class="btn btn-primary btn-sm min-w-4" variant="primary">Add</b-button></div></div>

      <div class="table-responsive" style="min-height: 2.5rem">
        <b-table :fields="requestFormsSetting" :items="request_form_list"
                 small
                 selectable
                 select-mode="single"
                 thead-class="thead-light text-dark"
                 style="width: calc(100% - 10px)"
                 @row-selected="selctRequestForm"
                 :tbody-tr-class="rowClass">
          <template #cell(action)="data">

            <div style="display:inline">
              <a v-if="data.item.status!='ONGOING'" class="btn btn-primary" target="_blank" :href="safeUrl(`${frontEndUrlToUse}ftie/request-form-approval/${ data.item.uni_id}`)">Approval</a>
              <a class="btn btn-primary" target="_blank" :href="safeUrl(`${ $root.frontEndUrl }/nre/customization-nre-pn/${ftie_page_obj.ftie_id}/${ftie_page_obj.request_detail_id}/${ data.item.uni_id}`)">Init NRE/Maintain PN</a>
              <a class="btn btn-primary" @click="copyRequestForm(data.item)">Copy</a>
              <a class="btn btn-primary" v-if="data.item.status ==='Submited'" @click="withdrawRequestForm(data.item)">Withdraw</a>
            </div>
            <!-- https://10.68.90.169:9001/ftie/NRE_FLOW/new_set_customer_pn.aspx?ftie_id=15993&detail_id=12188&request_form_id=2213 -->
          </template>
        </b-table>
      </div>
    </div>
    <div style="margin-bottom: 6rem;">
      <div class="border-bottom pb-4 mb-4">
        <div class="row">
          <div class="col-12">
            <div class="caption-label d-flex">
              <div>ETO NRE</div>
            </div>
            <div>
              <div>
                <b-table small thead-class="thead-light text-dark" v-if="current_request_form != null && current_request_form.ref_nres != null"
                         :items="current_request_form.ref_nres" :fields="nreTableSetting">
                  <template #cell(status)="data">
                    {{ data.item.status | etoSignStausFormat }}
                  </template>
                </b-table>
              </div>
            </div>
            <!--#endregion-->
          </div>
          <div class="col-12" style="min-width: 60rem;">
            <!--#region NRE Estimation-->
            <div class="stage-body-nre-estimation">
              <div class="caption-label">Customization Request Form</div>
              <table class="table  table-sm" border="1" v-if="current_request_form != null">
                <tr>
                  <td colspan="4" class="bg-gray-150">
                    ES Ticket ID/Request Form ID: <label style="color: red"> {{ current_request_form.ftie_id}} </label>/<label style="color: red"> {{ current_request_form.uni_id}}</label>
                  </td>
                </tr>
                <tr>
                  <td colspan="4" class="bg-gray-150">
                    FTIE Ticket Type: <label style="color: red"> {{ ftie_page_obj.type}} </label>
                  </td>
                </tr>
                <tr>
                  <td colspan="4" class="bg-gray-150">
                    1.Basic Information
                  </td>
                </tr>
                <tr>
                  <td class="bg-gray-150" width="25%">
                    Business Center
                  </td>
                  <td width="25%">
                    <div :class="validateClassObject(_.get(current_request_form, 'center', ''), 30)">
                      <span>You've input: {{ _.get(current_request_form, 'center', '') | getInputLength }}/30</span>
                    </div>
                    <gtc-textarea :read-only="true" v-model="current_request_form.center" />
                  </td>
                  <td class="bg-gray-150" width="25%">
                    GRO
                  </td>
                  <td width="25%">
                    <div :class="validateClassObject(_.get(current_request_form, 'gro', ''), 50)">
                      <span>You've input: {{ _.get(current_request_form, 'gro', '') | getInputLength }}/50</span>
                    </div>
                    <gtc-textarea :read-only="true" v-model="current_request_form.gro" />
                  </td>
                </tr>
                <tr>
                  <td class="bg-gray-150">
                    Model
                  </td>
                  <td>
                    <div :class="validateClassObject(_.get(current_request_form, 'model', ''), 50)">
                      <span>You've input: {{ _.get(current_request_form, 'model', '') | getInputLength }}/50</span>
                    </div>
                    <gtc-textarea :read-only="true" v-model="current_request_form.model" />
                  </td>
                  <td class="bg-gray-150">
                    Customer
                  </td>
                  <td>
                    <div :class="validateClassObject(_.get(current_request_form, 'company', ''), 100)">
                      <span>You've input: {{ _.get(current_request_form, 'company', '') | getInputLength }}/100</span>
                    </div>
                    <gtc-textarea :read-only="true" v-model="current_request_form.company" />
                  </td>
                </tr>
                <tr>
                  <td class="bg-gray-150">
                    Apply Date
                  </td>
                  <td>
                    <gtc-textarea :read-only="true" v-model="current_request_form.apply_date" />
                  </td>
                  <td class="bg-gray-150">
                    Vertical Market
                  </td>
                  <td>
                    <div :class="validateClassObject(_.get(current_request_form, 'vertical', ''), 100)">
                      <span>You've input: {{ _.get(current_request_form, 'vertical', '') | getInputLength }}/100</span>
                    </div>
                    <gtc-textarea :read-only="true" v-model="current_request_form.vertical" />
                  </td>
                </tr>
                <tr>
                  <td class="bg-gray-150">
                    Applicant
                  </td>
                  <td>
                    <div :class="validateClassObject(_.get(current_request_form, 'vertical', ''), 30)">
                      <span>You've input: {{ _.get(current_request_form, 'vertical', '') | getInputLength }}/30</span>
                    </div>
                    <gtc-textarea :read-only="true" v-model="current_request_form.applicant" />
                  </td>
                  <td class="bg-gray-150">
                    Opportunity Name
                  </td>
                  <td>
                    <div :class="validateClassObject(_.get(current_request_form, 'project', ''), 200)">
                      <span>You've input: {{ _.get(current_request_form, 'project', '') | getInputLength }}/200</span>
                    </div>
                    <gtc-textarea :read-only="true" v-model="current_request_form.project" />
                  </td>
                </tr>
                <tr>
                  <td colspan="4" class="bg-gray-150">
                    2.Business Evaludation
                  </td>
                </tr>
                <tr>
                  <td class="bg-gray-150">
                    Quotation Quantity
                  </td>
                  <td>
                    <div :class="validateClassObject(_.get(current_request_form, 'qty', ''), 10)">
                      <span>You've input: {{ _.get(current_request_form, 'qty', '') | getInputLength }}/10</span>
                    </div>
                    <gtc-textarea :read-only="check_current_request_form_submitted" v-model="current_request_form.qty" />
                  </td>
                  <td class="bg-gray-150">
                    Roll Out Schedule
                  </td>
                  <td>
                    <!--<gtc-textarea :read-only="false" v-model="roll_out_schedule" />-->
                    <input type="text" class="form-control" v-model="current_request_form.schedule" v-datepicker :disabled="check_current_request_form_submitted" />
                  </td>
                </tr>
                <tr>
                  <td class="bg-gray-150">
                    Total Amount
                  </td>
                  <td>
                    <div :class="validateClassObject(_.get(current_request_form, 'price', ''), 30)">
                      <span>You've input: {{ _.get(current_request_form, 'price', '') | getInputLength }}/30</span>
                    </div>
                    <gtc-text-box :read-only="check_current_request_form_submitted" v-model="current_request_form.price" />
                  </td>
                  <td class="bg-gray-150">
                    Qualified Customer?
                  </td>
                  <td>
                    <div :class="validateClassObject(_.get(current_request_form, 'qualified', ''), 10)">
                      <span>You've input: {{ _.get(current_request_form, 'qualified', '') | getInputLength }}/10</span>
                    </div>
                    <gtc-textarea :read-only="check_current_request_form_submitted" v-model="current_request_form.qualified" />
                  </td>
                </tr>
                <tr>
                  <td class="bg-gray-150">
                    Strategic Consideration
                  </td>
                  <td colspan="3">
                    <div :class="validateClassObject(_.get(current_request_form, 'strategic', ''), 300)">
                      <span>You've input: {{ _.get(current_request_form, 'strategic', '') | getInputLength }}/300</span>
                    </div>
                    <gtc-textarea :read-only="check_current_request_form_submitted" v-model="current_request_form.strategic" />
                  </td>
                </tr>
                <tr>
                  <td colspan="4" class="bg-gray-150">
                    3.Customization Requirement
                  </td>
                </tr>
                <tr>
                  <td class="bg-gray-150" width="25%">
                    Hardware Modification
                  </td>
                  <td colspan="3">
                    <div :class="validateClassObject(_.get(current_request_form, 'hardware_m', ''), 500)">
                      <span>You've input: {{ _.get(current_request_form, 'hardware_m', '') | getInputLength }}/500</span>
                    </div>
                    <gtc-textarea :read-only="check_current_request_form_submitted" v-model="current_request_form.hardware_m" />
                  </td>
                </tr>
                <tr>
                  <td class="bg-gray-150">
                    Software Modification
                  </td>
                  <td colspan="3">
                    <div :class="validateClassObject(_.get(current_request_form, 'software_m', ''), 2000)">
                      <span>You've input: {{ _.get(current_request_form, 'software_m', '') | getInputLength }}/2000</span>
                    </div>
                    <gtc-textarea :read-only="check_current_request_form_submitted" v-model="current_request_form.software_m" />
                  </td>
                </tr>
                <tr>
                  <td class="bg-gray-150">
                    Mechincal Modification
                  </td>
                  <td colspan="3">
                    <div :class="validateClassObject(_.get(current_request_form, 'me_m', ''), 300)">
                      <span>You've input: {{ _.get(current_request_form, 'me_m', '') | getInputLength }}/300</span>
                    </div>
                    <gtc-textarea :read-only="check_current_request_form_submitted" v-model="current_request_form.me_m" />
                  </td>
                </tr>
                <tr>
                  <td class="bg-gray-150">
                    Application
                  </td>
                  <td colspan="3">
                    <div :class="validateClassObject(_.get(current_request_form, 'application', ''), 300)">
                      <span>You've input: {{ _.get(current_request_form, 'application', '') | getInputLength }}/300</span>
                    </div>
                    <gtc-textarea :read-only="check_current_request_form_submitted" v-model="current_request_form.application" />
                  </td>
                </tr>
                <tr>
                  <td class="bg-gray-150">
                    Safety/Regulation
                  <td colspan="3">
                    <div :class="validateClassObject(_.get(current_request_form, 'safety', ''), 300)">
                      <span>You've input: {{ _.get(current_request_form, 'safety', '') | getInputLength }}/300</span>
                    </div>
                    <gtc-textarea :read-only="check_current_request_form_submitted" v-model="current_request_form.safety" />
                  </td>
                </tr>
                <tr>
                  <td class="bg-gray-150">
                    Special Test Procedure and Manufacturing Requirement
                  </td>
                  <td colspan="3">
                    <div :class="validateClassObject(_.get(current_request_form, 'special', ''), 1000)">
                      <span>You've input: {{ _.get(current_request_form, 'special', '') | getInputLength }}/1000</span>
                    </div>
                    <gtc-textarea :read-only="check_current_request_form_submitted" v-model="current_request_form.special" />
                  </td>
                </tr>
                <tr>
                  <td class="bg-gray-150">
                    Others
                  </td>
                  <td colspan="3">
                    <div :class="validateClassObject(_.get(current_request_form, 'others', ''), 1000)">
                      <span>You've input: {{ _.get(current_request_form, 'others', '') | getInputLength }}/1000</span>
                    </div>
                    <gtc-textarea :read-only="check_current_request_form_submitted" v-model="current_request_form.others" />
                  </td>
                </tr>
                <tr v-if="check_current_request_form_submitted === false">
                  <td colspan="4" class="text-dark thead-light">
                    <div class="col-12 align-self-right">
                      <b-button @click="lengthValidate() && saveRequestForm('save')" style="width: 9.5rem" variant="primary">Save</b-button>
                      <b-button @click="lengthValidate() && saveRequestForm('submit')" style="width: 9.5rem" variant="primary">Apply</b-button>
                      <b-button v-if="current_request_form!=null && current_request_form.status=='ONGOING'" @click="resetRequestFormInput()" style="width: 9.5rem" variant="primary">Clear</b-button>
                    </div>
                  </td>
                </tr>
              </table>

            </div>
            <!--#endregion-->
          </div>

          <div class="col-12">
            <!--#region Reference Files-->
            <div class="caption-label d-flex">
              <div>Request Form Reference Files</div>
              <div class="ml-3 d-print-none" v-if="current_request_form!=null && current_request_form.status=='ONGOING'">
                <div class="d-flex align-items-center">
                  <b-form-file ref="fileInput"
                               v-model="selectedFile"
                               placeholder="Please select or drop file..."
                               drop-placeholder="Drop your file here..."></b-form-file>
                  <b-button class="ml-2" @click="uploadfile()" variant="primary">Upload</b-button>
                </div>
                <!--<label class="btn btn-primary btn-sm">
                  <span>Upload</span>
                  <input type="file" class="d-none" v-on:change="uploadfile($event)" />
                </label>-->
              </div>
            </div>
            <div class="pt-2">
              <b-table small thead-class="thead-light text-dark" style="table-layout: fixed;" v-if="current_request_form != null && current_request_form.ref_upload_files != null"
                       :items="filter_current_request_form_ref_files" :fields="referenceFilesSetting">

                <template #cell(file_name)="data">
                  <a class="link" @click="downloadAttachment(data.item.file_name,  data.item.old_file_name )">{{ data.item.old_file_name }}</a>
                </template>
                <template #cell(create_date)="data">
                  {{ _.get(data.item, 'create_date', '') | dateFormat }}
                </template>
                <template #cell(delete)="data">
                  <button v-if="current_request_form.status==='ONGOING'" type="button" class="btn btn-link p-0 btn-svg gtc-icon-delete"
                          @click="deleteFile(data.item.uni_id)"></button>
                </template>
              </b-table>
            </div>
            <!--#endregion-->
          </div>
        </div>

      </div>

    </div>
  </div>
  <div v-else class="mb-4">
    <!--
      <div>
        <h1>Permission Required!</h1>
        <p>
          You don't have enough permission to access this page.
        </p>
      </div>
    -->
  </div>
</template>
<script>
  import * as moment from 'moment/moment';
  import { safeUrl } from '@/helpers/vue-url';
  export default {
    name: 'request-form',
    data() {
      return {
        accessRequestFormPage: false,
        function_name: 'Customization Request Form',
        dateFormat: { year: 'numeric', month: 'short', day: 'numeric' },
        current_request_form: null,
        request_form_list: [],
        requestFormsSetting: [
          { key: 'action', label: 'Action', thClass: 'align-middle ', sortable: false },
          { key: 'uni_id', label: 'RequestForm#', thClass: 'align-middle ', sortable: false },
          { key: 'project', label: 'Opty Name', thClass: 'align-middle ', sortable: false },
          { key: 'vertical', label: 'Vertical', thClass: 'align-middle', sortable: false },
          { key: 'create_date', label: 'Create Date', thClass: 'align-middle', sortable: false },
          { key: 'qty', label: 'Quantity', thClass: 'align-middle', sortable: false },
          { key: 'price', label: 'Price', thClass: 'align-middle', sortable: false },
          { key: 'status', label: 'Status', thClass: 'align-middle', sortable: false },
          { key: 'ongoing_status', label: 'Ongoing Status', thClass: 'align-middle', sortable: false }
        ],
        referenceFilesSetting: [
          { key: 'file_name', label: 'File Name', thClass: 'align-middle ', sortable: false },
          { key: 'create_date', label: 'Create Date', thClass: 'align-middle ', sortable: false },
          { key: 'delete', label: 'Action', thClass: 'align-middle ', sortable: false }
        ],
        nreTableSetting: [
          { key: 'nre_id', label: 'ETO NRE', thClass: 'align-middle ', sortable: false },
          { key: 'status', label: 'NRE Status', thClass: 'align-middle ', sortable: false },
          { key: 'nre_stage', label: 'Signing Stage', thClass: 'align-middle ', sortable: false },
          //{ key: 'update_date', label: 'Update Date', thClass: 'align-middle ', sortable: false },
        ],
        ftie_page_obj: {},
        login_user_name: null,
        userSites: null,
        userRoles: null,
        userFunctions: null,
        frontEndUrlToUse: this.$session.get('frontEndUrlToUse'),
        sf_es_info: {},
        sf_opty_info: {},
        selectedFile: null
      }
    },
    created() {
      let self = this;
      self.checkLoggedIn();
      self.getRequestForms();
    },
    mounted() {
      this.checkLoggedIn();
    },
    computed: {
      check_current_request_form_submitted() {
        let self = this;
        if (self.current_request_form != null && self.current_request_form.status !== 'ONGOING') {
          return true;
        } else {
          return false;
        }
      },
      filter_current_request_form_ref_files() {
        let self = this;
        let filter_files = [];
        if (self.current_request_form != null && self.current_request_form.ref_upload_files != null && self.current_request_form.ref_upload_files != []) {
          filter_files = _.filter(self.current_request_form.ref_upload_files, item => { return moment(item.create_date).isAfter(self.current_request_form.create_date) && (moment(item.create_date).isBefore(self.current_request_form.apply_date) || self.current_request_form.apply_date == null); });
          return filter_files;
        } else {
          return filter_files;
        }
      }
    },
    //watch: {
    //  // 監聽 selectedFile 的變化
    //  selectedFile(newFile) {
    //    let self = this;
    //    if (newFile) {
    //      self.uploadfile()
    //    }
    //  }
    //},
    methods: {

      ifAccessRequestFormPage() {
        let self = this;
        if (
          (self.login_user_name === self.ftie_page_obj.gtc_owner) || self.$options.filters['adminAccessFtie'](self.login_user_name, null, null) === true
          || (self.userSites && self.userSites.includes('Getac') && self.userFunctions && _.indexOf(self.userFunctions, 'Tech Leader') > -1)
        ) {
          self.accessRequestFormPage = true;
        } else {
          self.accessRequestFormPage = false;
        }
      },

      // checkIsOwnerOrAdmin() {
      // let self = this;
      // console.log("_.indexOf(self.userFunctions, 'Tech Leader')");
      // console.log(_.indexOf(self.userFunctions, 'Tech Leader'))
      //if (self.login_user_name !== self.ftie_page_obj.gtc_owner
      //&& self.login_user_name !== 'power' && (_.indexOf(self.user_functions, 'Tech Leader') < 0)
      // && self.$options.filters['adminAccessFtie'](self.login_user_name, null, null) === false) {
      // self.$message.warning('No acees permission', self.function_name);
      //}
      // },

      prdEnv() {
        return 'PRD' === this.$session.get('mode');
        //return 'DEV' !== this.$session.get('mode');
      },
      newRequestForm() {
        let self = this;
        let login_user_name = self.$session.get('user_name');
        //self.current_request_form = null;
        self.current_request_form = {
          "uni_id": null,
          "ticket_type": _.get(self.ftie_page_obj, 'type', null),
          "applicant": login_user_name,
          "application": null,
          "apply_date": moment(new Date(), 'YYYY-MM-DD HH:MM:SS').format('YYYY-MM-DD HH:mm:ss'),
          "center": "RSBU",
          "company": self.ftie_page_obj.customer,
          "create_by": login_user_name,
          "create_date": moment(new Date(), 'YYYY-MM-DD HH:MM:SS').format('YYYY-MM-DD HH:mm:ss'),
          "enable": "Y",
          "ftie_id": self.ftie_page_obj.ftie_id,
          "gro": self.ftie_page_obj.site,
          "hardware_m": null,
          "me_m": null,
          "model": self.ftie_page_obj.device,
          "others": null,
          "price": self.sf_opty_info.OPPORTUNITY_CURRENCY + self.$options.filters['comma'](self.sf_opty_info.AMOUNT, 2),
          "project": self.sf_opty_info.OPPORTUNITY_NAME,
          "qty": self.sf_opty_info.SYSTEM_QUANTITY,
          "qualified": "YES",
          "ref_nres": [],
          "ref_upload_files": [],
          "safety": null,
          "schedule": null,
          "software_m": null,
          "special": null,
          "strategic": null,
          "status": "ONGOING",
          "vertical": self.sf_opty_info.VERTICAL_INDUSTRY__C
        }
      },
      copyRequestForm(requet_form) {
        let self = this;
        let login_user_name = self.$session.get('user_name');
        //self.current_request_form = null;
        self.current_request_form = JSON.parse(JSON.stringify(requet_form));
        self.current_request_form.uni_id = null;
        self.current_request_form.applicant = login_user_name;
        self.current_request_form.apply_date = moment(new Date(), 'YYYY-MM-DD HH:MM:SS').format('YYYY-MM-DD HH:mm:ss');
        self.current_request_form.create_date = moment(new Date(), 'YYYY-MM-DD HH:MM:SS').format('YYYY-MM-DD HH:mm:ss');
        self.current_request_form.status = "ONGOING";
        self.current_request_form.ticket_type = _.get(self.ftie_page_obj, 'type', null);
      },
      selctRequestForm(item, index, event) {
        let self = this;
        self.current_request_form = item[0];
        if (self.current_request_form.status === 'ONGOING') {
          self.current_request_form.apply_date = moment(new Date(), 'YYYY-MM-DD HH:MM:SS').format('YYYY-MM-DD HH:mm:ss');
        }
      },
      rowClass(item, type) {
        let self = this;
        if (item && type === 'row') {
          if (item.uni_id === self.current_request_form.uni_id) {
            return 'b-table-row-selected table-active'
          } else {
            return ''
          }
        } else {
          return null
        }
      },
      getRequestForms() {
        let self = this;
        let url = self.$root.baseUrl + '/ftie/request-form/';
        let request_data = {
          ftie_id: self.$route.params.ftie_id
        };

        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        let request_form_list = null;
        let ftie_page_obj = null;
        eventHub.$emit('loading', true);
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
              request_form_list = JSON.parse(res['request_form_list']);
              ftie_page_obj = JSON.parse(res['ftie_page_obj']);
              self.request_form_list = request_form_list;
              if (request_form_list != null && request_form_list.length > 0) {
                self.current_request_form = self.request_form_list[0];
                //self.current_request_form.apply_date = moment(new Date(), 'YYYY-MM-DD HH:MM:SS').format('YYYY-MM-DD HH:mm:ss');
              }
              self.ftie_page_obj = ftie_page_obj;
            }
            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
              //console.log(res['msg'])
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            // self.checkIsOwnerOrAdmin(); permission check move to the top
            self.ifAccessRequestFormPage();
            self.getSfEsOptyInfo();
            eventHub.$emit('loading', false);
          })
      },
      resetRequestFormInput() {
        let self = this;
        self.current_request_form.application = null;
        self.current_request_form.hardware_m = null;
        self.current_request_form.me_m = null;
        self.current_request_form.others = null;
        self.current_request_form.safety = null;
        self.current_request_form.software_m = null;
        self.current_request_form.special = null;
        self.current_request_form.strategic = null;
        self.current_request_form.ticket_type = _.get(self.ftie_page_obj, 'type', null);

      },
      saveRequestForm(action) {
        let self = this;
        let url = self.$root.baseUrl + '/ftie/save-request-form/';
        let request_data = {
          request_form: self.current_request_form,
          action: action
        };

        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        eventHub.$emit('loading', true);
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
              let save_success = JSON.parse(res['save_success']);
              if (save_success) {
                //window.location = this.$root.frontEndUrl + '/ftie/request-form' + '/' + encodeURIComponent(self.$route.params.ftie_id);
                window.location = this.frontEndUrlToUse + 'ftie/request-form' + '/' + encodeURIComponent(self.$route.params.ftie_id);
              }
            }
            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
              //console.log(res['msg'])
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
          })
      },
      deleteFile(uni_id) {
        let self = this;
        let url = self.$root.baseUrl + '/ftie/delete-upload-file/';
        let request_data = {
          ftie_id: self.ftie_page_obj.ftie_id,
          uni_id: uni_id
        };

        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        eventHub.$emit('loading', true);
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
              let save_success = JSON.parse(res['save_success']);
              if (save_success) {
                //window.location = this.$root.frontEndUrl + '/ftie/request-form' + '/' + encodeURIComponent(self.$route.params.ftie_id);
                //window.location = this.frontEndUrlToUse + 'ftie/request-form' + '/' + encodeURIComponent(self.$route.params.ftie_id);
                self.saveRequestForm('save');
              }
            }
            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
              //console.log(res['msg'])
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
          })
      },
      uploadfile() {
        let self = this;
        let maxLength = Number(self.$root.maxRequestLength);
        if (self.selectedFile) {
          if (self.selectedFile.size > maxLength) {
            self.$message.warning('Maximum limit for exceeding single file uploads (10MB)');
            return;
          } else {
            let request_data = {
              ftie_id: self.ftie_page_obj.ftie_id,
              user_name: self.$store.state.username,
              result_id: self.ftie_page_obj.ftie_id,
              user_role: 'GTC Owner',
              file_category: 'Request_mtc'
            };
            //#region -- formData --
            let formData = new FormData();
            formData.append('file', self.selectedFile);
            formData.append('ftie_id', self.ftie_page_obj.ftie_id);
            formData.append('user_name', self.$store.state.username);
            formData.append('result_id', self.ftie_page_obj.ftie_id);
            formData.append('user_role', 'GTC Owner');
            formData.append('file_category', 'Request_mtc');
            //#endregion

            //#region -- Data Upload --

            eventHub.$emit('loading', true);
            self.$axios
              .post(
                self.$root.baseUrl + '/ftie/upload-file/',
                formData,
                { headers: { 'Content-Type': 'multipart/form-data' } }
              )
              .then(res => {
                //window.location = this.$root.frontEndUrl + '/ftie/request-form' + '/' + encodeURIComponent(self.$route.params.ftie_id);
                self.saveRequestForm('save');
              })
              .finally(() => {
                eventHub.$emit('loading', false);
                self.selectedFile = null;
              });
          }
        } else {
          self.$message.warning('No file');
        }

      },
      checkLoggedIn() {
        if (!this.$session.has('user_name')) {
          this.$router.push("/");
        }

        var user_name = this.$session.get('user_name');
        var options = this.$session.get('options');
        var user_email = this.$session.get('user_id');
        var user_functions = this.$session.get('user_functions');
        var user_roles = this.$session.get('user_roles');
        var user_site = this.$session.get('user_site');

        console.log("this.$session.get('options')");
        console.log(options);
        console.log(options.model_list);
        console.log("login_user_name:");
        console.log(user_name);
        console.log("user_email:");
        console.log(user_email);
        console.log("user_functions:");
        console.log(user_functions);
        console.log("user_roles:");
        console.log(user_roles);
        console.log("user_site:");
        console.log(user_site);


        this.login_user_name = user_name;
        this.userSites = user_site;
        this.userRoles = user_roles;
        this.userFunctions = user_functions;

      },
      validateClassObject(input, maxLength) {
        return {
          'text-danger': this.$options.filters['reachLength'](input, maxLength),
          'text-success': !this.$options.filters['reachLength'](input, maxLength),
          'text-weight': this.$options.filters['reachLength'](input, maxLength) ? 'bold' : 'normal'//,
        }
      },
      lengthValidate() {
        let self = this;
        let validateColumnsDict = [
          { 'column': 'center', 'maxLength': 30 },
          { 'column': 'gro', 'maxLength': 50 },
          { 'column': 'model', 'maxLength': 50 },
          { 'column': 'company', 'maxLength': 100 },
          { 'column': 'vertical', 'maxLength': 100 },
          { 'column': 'applicant', 'maxLength': 30 },
          { 'column': 'project', 'maxLength': 200 },
          { 'column': 'qty', 'maxLength': 10 },
          { 'column': 'price', 'maxLength': 30 },
          { 'column': 'qualified', 'maxLength': 10 },

          { 'column': 'strategic', 'maxLength': 300 },
          { 'column': 'hardware_m', 'maxLength': 500 },
          { 'column': 'software_m', 'maxLength': 2000 },
          { 'column': 'me_m', 'maxLength': 300 },
          { 'column': 'application', 'maxLength': 300 },
          { 'column': 'safety', 'maxLength': 300 },
          { 'column': 'special', 'maxLength': 1000 },
          { 'column': 'others', 'maxLength': 1000 }
        ];


        /* MAX = 2000 */
        for (var i = 0; i < validateColumnsDict.length; i++) {
          /*
          if (validateColumns[i] === 'tech_info.es_issue' && _.get(self.esTicketInfo, validateColumns[i], '').length > 2000) {
            let text = `The max length of 2000 characters in Engineering Service Issue / Requirement is reached. You typed in ${_.get(self.esTicketInfo, validateColumns[i], '').length} characters`;

            self.$message.warning(text, 'Max Length Reached: Engineering Service Issue');
            return false;
          }*/

          if (_.get(self.current_request_form, validateColumnsDict[i]['column'], '') && _.get(self.current_request_form, validateColumnsDict[i]['column'], '').length > validateColumnsDict[i]['maxLength']) {
            let text = `The max length of ${validateColumnsDict[i]['maxLength']} characters in ${validateColumnsDict[i]['column']} is reached. You typed in ${_.get(self.current_request_form, validateColumnsDict[i]['column'], '').length} characters`;
            self.$message.warning(text, 'Max Length Reached');
            return false;
          }

        }

        // !! ALL LOOP COMPLETED, PASS THE LENGTH VALIDATION !!
        return true;
      },
      getSfEsOptyInfo() {
        let self = this;

        let requestData = {
          es_id: self.ftie_page_obj.salesforce_es_id,
          opty_id: self.ftie_page_obj.salesforce_opty_id
        };
        self.searching = true;
        eventHub.$emit('loading', true);
        this.$axios
          .post(self.$root.baseUrl + '/ftie/get-sf-info/', requestData)
          .then(res => {
            let result = res.data;

            if (_.get(result, 'sf_es_info', null) !== null) {
              self.sf_es_info = JSON.parse(result.sf_es_info);
            }

            if (_.get(result, 'sf_opty_info', null) !== null) {
              self.sf_opty_info = JSON.parse(result.sf_opty_info);
            }
          })
          .finally(() => {
            eventHub.$emit('loading', false);
          });

      },
      withdrawRequestForm(request_form) {
        let self = this;

        let requestData = {
          request_form_id: request_form.uni_id,
          login_user_name: self.login_user_name
        };
        self.searching = true;
        eventHub.$emit('loading', true);
        this.$axios
          .post(self.$root.baseUrl + '/ftie/request-form/withdraw/', requestData)
          .then(res => {
            let result = res.data;

            if (_.get(result, 'withdraw_success', null) !== true) {
              self.$message.warning(_.get(result, 'withdraw_message', null));
            } else {
              window.location = this.frontEndUrlToUse + 'ftie/request-form' + '/' + encodeURIComponent(self.$route.params.ftie_id);
            }
          })
          .finally(() => {
            eventHub.$emit('loading', false);
          });

      },
      downloadAttachment(file_name, origin_file_name) {
        let self = this;
        let url = self.$root.baseUrl + '/upload_file/' + file_name;
        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
          origin_file_name: origin_file_name
        };
        eventHub.$emit('loading', true);
        self.$axios.get(url, { params, responseType: 'arraybuffer' })
          .then((response) => {
            if (response.status === 200) {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement('a');
              link.href = url;
              console.log("file_name =" + origin_file_name);
              link.setAttribute('download', origin_file_name);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);
            }
            else if (response.status === 401) {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
          })
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/_RequestForm.vue